import { Component, Input, OnInit, ViewChildren, HostListener, Output, EventEmitter, AfterViewInit, Renderer2, ElementRef, ComponentFactoryResolver, EmbeddedViewRef, ApplicationRef, Injector, ViewChild } from '@angular/core';
import { ChatAdapter } from './core/chat-adapter';
import { Message } from "./core/message";
import { Window } from "./core/window";
import { UserStatus } from "./core/user-status.enum";
import { Localization, StatusDescription } from './core/localization';
import { map } from 'rxjs/operators';
import { ChatP } from '../chat/chat.model';
import { AuthService } from '../../shared/services/auth.service';
import { ChatService } from '../chat/chat.service';
import { SocketService } from '../../shared/services/socket.service';
import { MessageService } from '../../message.service';
import { User } from '../users/user.model';
import { Router } from '@angular/router';
import { IconChatsComponent } from '../../theme/components/sidenav/icon-chats/icon-chats.component';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { UsersService } from '../users/users.service';

@Component({
    selector: 'ng-chat',
    templateUrl: 'ng-chat.component.html',
    styleUrls: [
        'assets/icons.css',
        'assets/ng-chat.component.default.css',
        'assets/ng-chat.component.scss',
        'assets/loading-spinner.css'
    ],
    providers: [ UsersService ]
})

export class NgChat implements OnInit, AfterViewInit {
    constructor(
        private chatService: ChatService,
        private userService: UsersService,
        private router: Router,
        private messageService: MessageService,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector
    ) { }

    private socketService = SocketService.getInstance();
    // Exposes the enum for the template
    UserStatus = UserStatus;

    @Input()
    public adapter: ChatAdapter;

    @Input()
    public userId: any;

    @Input()
    public isCollapsed: boolean = true;

    @Input()
    public maximizeWindowOnNewMessage: boolean = true;

    @Input()    
    public pollFriendsList: boolean = false;

    @Input()
    public pollingInterval: number = 5000;

    @Input()    
    public historyEnabled: boolean = true;

    @Input()    
    public emojisEnabled: boolean = true;

    @Input()    
    public linkfyEnabled: boolean = true;

    @Input()
    public audioEnabled: boolean = true;

    @Input() // TODO: This might need a better content strategy
    public audioSource: string = 'https://raw.githubusercontent.com/rpaschoal/ng-chat/master/src/ng-chat/assets/notification.wav';

    @Input()
    public persistWindowsState: boolean = true;

    @Input()
    public title: string = "Chats";

    @Input()
    public messagePlaceholder: string = "Escribe el mensaje aquí";

    @Input()
    public searchPlaceholder: string = "Buscar";

    @Input()
    public browserNotificationsEnabled: boolean = true;

    @Input() // TODO: This might need a better content strategy
    public browserNotificationIconSource: string = 'https://raw.githubusercontent.com/rpaschoal/ng-chat/master/src/ng-chat/assets/notification.png';

    @Input()
    public browserNotificationTitle: string = "New message from";

    @Input()
    public localization: Localization;

    @Input()
    public seen: boolean;

    @Output()
    public onUserClicked: EventEmitter<ChatP> = new EventEmitter<ChatP>();

    @Output()
    public onUserChatOpened: EventEmitter<object> = new EventEmitter<object>();

    @Output()
    public onUserChatClosed: EventEmitter<ChatP> = new EventEmitter<ChatP>();

    @Output()
    public onSentMessage: EventEmitter<ChatP> = new EventEmitter<ChatP>();

    @Output()
    public onNewMessageReceived: EventEmitter<ChatP> = new EventEmitter<ChatP>();

    private browserNotificationsBootstrapped: boolean = false;

    private typing = false;
    private timeout = undefined;
    public newMessage: boolean;
    @ViewChild ('searchUser') searchUser: ElementRef;
    public name: FormControl = new FormControl();
    public filteredUsers1: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    public users1: User[];

    // Don't want to add this as a setting to simplify usage. Previous placeholder and title settings available to be used, or use full Localization object.
    private statusDescription: StatusDescription = {
        online: 'Online',
        busy: 'Busy',
        away: 'Away',
        offline: 'Offline'
    };

    private audioFile: HTMLAudioElement;

    public searchInput: string = '';

    private users: ChatP[];

    private get localStorageKey(): string 
    {
        return `ng-chat-users-${this.userId}`; // Appending the user id so the state is unique per user in a computer.   
    }; 

    get filteredUsers(): ChatP[]
    {
        if (this.searchInput.length > 0){
            // Searches in the friend list by the inputted search string
            return this.users.filter(x => x.to.name.toUpperCase().includes(this.searchInput.toUpperCase()));
        }

        return this.users;
    }

    // Defines the size of each opened window to calculate how many windows can be opened on the viewport at the same time.
    private windowSizeFactor: number = 320;

    // Total width size of the friends list section
    private friendsListWidth: number = 262;

    // Available area to render the plugin
    private viewPortTotalArea: number;

    windows: Window[] = [];

    isBootstrapped: boolean = false;

    @ViewChildren('chatMessages') chatMessageClusters: any;

    @ViewChildren('chatWindowInput') chatWindowInputs: any;

  

    ngOnInit() { 
        this.bootstrapChat();
        
        this.messageService.onStopTyping.subscribe(chat => {
            console.log('get stop-typing from ' + chat.from.name);

            let openedWindow = this.windows.find(x => x.chattingTo.to.id == chat.from.id);
      
            if(openedWindow) {
              if(openedWindow.chattingTo.to.id === chat.from.id) {
                openedWindow.chattingTo.messages.splice(openedWindow.chattingTo.messages.findIndex(x => x.typing == true), (openedWindow.chattingTo.messages.findIndex(x => x.typing == true) != -1 ? 1 : 0));
                this.scrollChatWindowToBottom(openedWindow);
              }
            }
      
            if(AuthService.chats) {
              AuthService.chats.map(x => {
                if(x.to.id == chat.from.id) {
                  x.typing = false;
                }
              });
            }
      
            // if(AuthService.chats) {
            //   AuthService.chats.map(x => {
            //     if(x.to.id == user.id) {
            //       this.lastTime = moment().calendar();
            //       x.status = user['status'];
            //     }
            //   });
            // }
          });

          if(AuthService.getUser().role.id != 4 && !AuthService.getUser().role.name.includes('Alumno')) {
            this.userService.getAllUsers(AuthService.getUser().id).subscribe(users => {
                this.users1 = users;
        
                this.filteredUsers1.next(this.users1);
            });
          } else {
              this.userService.getAllUsersChatStudent(AuthService.getUser().id).subscribe(users => {
                this.users1 = users;
        
                this.filteredUsers1.next(this.users1);
            });
          }

          this.name.valueChanges.pipe().subscribe(() => {
            this.filterUsers();
          });

        this.messageService.onTyping.subscribe(chat => {
            console.log('get typing from ' + chat.from.name);

            let openedWindow = this.windows.find(x => x.chattingTo.to.id == chat.from.id);
      
            if(openedWindow) {
              if(openedWindow.chattingTo.to.id === chat.from.id) {
                const typing = new ChatP();
                typing.typing = true;
                typing.message = 'escribiendo...';
                
                openedWindow.chattingTo.messages.push(typing);
                this.scrollChatWindowToBottom(openedWindow);
              }
      
              if(openedWindow.chattingTo.to.id !== chat.from.id) {
                AuthService.chats.map(x => {
                  if(x.to.id == chat.from.id) {
                    x.typing = true;
                  }
                });
              }
            } else {
              AuthService.chats.map(x => {
                if(x.to.id == chat.from.id) {
                  x.typing = true;
                }
              });
            }
      
            // if(AuthService.chats) {
            //   AuthService.chats.map(x => {
            //     if(x.to.id == user.id) {
            //       this.lastTime = moment().calendar();
            //       x.status = user['status'];
            //     }
            //   });
            // }
          });

        this.messageService.onMessageReceived.subscribe(message => {
            //debugger
            console.log(message);

            // const from = message.from;
            // message.from = message.to;
            // message.to = from;
            
            let chatWindow = this.openChatWindow(AuthService.chats.find(x => x.to.id == message.from.id));
            chatWindow[0].hasNewMessage = true;
            if(chatWindow[0].hasFocus) {
                // AuthService.chats.map(x => {
                //     if(x.to.id == chatWindow[0].chattingTo.to.id) {
                //         x.countNewMessage = 0;
                //     }
                // });
    
                this.chatService.markAsSeen({from: chatWindow[0].chattingTo.to.id, to: chatWindow[0].chattingTo.from.id}).subscribe(resp => {
                    console.log(resp);
                    this.socketService.sendMarkMessageSeen(chatWindow[0].chattingTo);
                });

           }
            
            AuthService.chats.find(x => x.to.id == message.from.id).messages.splice(AuthService.chats.find(x => x.to.id == message.from.id).messages.findIndex(x => x.typing == true), (AuthService.chats.find(x => x.to.id == message.from.id).messages.findIndex(x => x.typing == true) != -1 ? 1 : 0));

            this.onNewMessageReceived.emit(message);

            if (!chatWindow[1] || !this.historyEnabled){
                //chatWindow[0].messages.push(message);

                this.scrollChatWindowToBottom(chatWindow[0]);
            }
        });

        

          this.messageService.onStopTyping.subscribe(chat => {
            console.log('get stop-typing from ' + chat.from.name);

            let openedWindow = this.windows.find(x => x.chattingTo.to.id == chat.from.id);
      
            if(openedWindow) {
              if(openedWindow.chattingTo.to.id === chat.from.id) {
                openedWindow.chattingTo.messages.splice(openedWindow.chattingTo.messages.findIndex(x => x.typing == true), (openedWindow.chattingTo.messages.findIndex(x => x.typing == true) != -1 ? 1 : 0));
                this.scrollChatWindowToBottom(openedWindow);
              }
            }
      
            if(AuthService.chats) {
              AuthService.chats.map(x => {
                if(x.to.id == chat.from.id) {
                  x.typing = false;
                }
              });
            }
      
            // if(AuthService.chats) {
            //   AuthService.chats.map(x => {
            //     if(x.to.id == user.id) {
            //       this.lastTime = moment().calendar();
            //       x.status = user['status'];
            //     }
            //   });
            // }
          });
    }

    private filterUsers() {
        if (!this.users1) {
          return;
        }
    
        // get the search keyword
        let search = this.name.value;
        if (!search) {
          this.filteredUsers1.next(this.users1);
          return;
        } else {
          search = search.toLowerCase();
        }
        // filter the banks
        this.filteredUsers1.next(
          this.users1.filter(x => (x.name + ' ' + x.lastname).toLowerCase().indexOf(search) > -1)
        );
      }

    ngAfterViewInit() {
        
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any){
       this.viewPortTotalArea = event.target.innerWidth;

       this.NormalizeWindows();
    }

    // Checks if there are more opened windows than the view port can display
    private NormalizeWindows(): void
    {
        let maxSupportedOpenedWindows = Math.floor(this.viewPortTotalArea / this.windowSizeFactor);
        let difference = this.windows.length - maxSupportedOpenedWindows;

        if (difference >= 0){
            this.windows.splice(this.windows.length - 1 - difference);
        }
    }

    // Initializes the chat plugin and the messaging adapter
    private bootstrapChat(): void
    {
        if (this.adapter != null && this.userId != null)
        {
            this.viewPortTotalArea = window.innerWidth;

            this.initializeDefaultText();
            this.initializeBrowserNotifications();

            // Binding event listeners
            this.adapter.messageReceivedHandler = (user, msg) => this.onMessageReceived(user, msg);
            this.adapter.friendsListChangedHandler = (users) => this.onFriendsListChanged(users);

            // Loading current users list
            if (this.pollFriendsList){
                // Setting a long poll interval to update the friends list
                this.fetchFriendsList(true);
                setInterval(() => this.fetchFriendsList(false), this.pollingInterval);
            }
            else
            {
                // Since polling was disabled, a friends list update mechanism will have to be implemented in the ChatAdapter.
                this.fetchFriendsList(true);
            }
            
            this.bufferAudioFile();
            
            this.isBootstrapped = true;
        }

        if (!this.isBootstrapped){
            console.error("ng-chat component couldn't be bootstrapped.");
            
            if (this.userId == null){
                console.error("ng-chat can't be initialized without an user id. Please make sure you've provided an userId as a parameter of the ng-chat component.");
            }
            if (this.adapter == null){
                console.error("ng-chat can't be bootstrapped without a ChatAdapter. Please make sure you've provided a ChatAdapter implementation as a parameter of the ng-chat component.");
            }
        }
    }

    // Initializes browser notifications
    private async initializeBrowserNotifications()
    {
        if (this.browserNotificationsEnabled && ("Notification" in window))
        {
            if (await Notification.requestPermission())
            {
                this.browserNotificationsBootstrapped = true;
            }
        }
    }

    // Initializes default text
    private initializeDefaultText() : void
    {
        if (!this.localization)
        {
            this.localization = {
                messagePlaceholder: this.messagePlaceholder,
                searchPlaceholder: this.searchPlaceholder, 
                title: this.title,
                statusDescription: this.statusDescription,
                browserNotificationTitle: this.browserNotificationTitle
            };
        }
    }

    // Sends a request to load the friends list
    private fetchFriendsList(isBootstrapping: boolean): void
    {
        this.adapter.listFriends().pipe(
        map((users: ChatP[]) => {
            this.users = users;
        })).subscribe(() => {
            if (isBootstrapping)
            {
                this.restoreWindowsState();
            }
        });
    }

    // Updates the friends list via the event handler
    private onFriendsListChanged(users: ChatP[]): void
    {
        if (users) 
        {
            this.users = users;
        }
    }

    // Handles received messages by the adapter
    private onMessageReceived(user: ChatP, message: ChatP)
    {
        //debugger
        //if (user)
        //{
            let chatWindow = this.openChatWindow(user);

            if (!chatWindow[1] || !this.historyEnabled){
                //chatWindow[0].messages.push(message);

                this.scrollChatWindowToBottom(chatWindow[0]);
            }

            this.chatService.save(user).subscribe(id => {
                message.id = id;
                this.socketService.sendNewChatMessage(user);
              });

            //this.emitMessageSound(chatWindow[0]);
            
            // Github issue #58 
            // Do not push browser notifications with message content for privacy purposes if the 'maximizeWindowOnNewMessage' setting is off and this is a new chat window.
            // if (this.maximizeWindowOnNewMessage || (!chatWindow[1] && !chatWindow[0].isCollapsed))
            // { 
            //     // Some messages are not pushed because they are loaded by fetching the history hence why we supply the message here
            //     this.emitBrowserNotification(chatWindow[0], message);
            // }
       // }
    }

    // Opens a new chat whindow. Takes care of available viewport
    // Returns => [Window: Window object reference, boolean: Indicates if this window is a new chat window]
    public openChatWindow(user: ChatP, focusOnNewWindow: boolean = false, invokedByUserClick: boolean = false): [Window, boolean]
    {
        // Is this window opened?
        //debugger
        let openedWindow = this.windows.find(x => x.chattingTo.to.id == user.to.id);

        if (!openedWindow)
        {
            if (invokedByUserClick) 
            {
                this.onUserClicked.emit(user);
            }

            // const from = user.from;
            // user.from = user.to;
            // user.to = from;

            // Refer to issue #58 on Github 
            let collapseWindow = invokedByUserClick ? false : !this.maximizeWindowOnNewMessage;

            let newChatWindow: Window = {
                chattingTo: user,
                messages:  [],
                isLoadingHistory: this.historyEnabled,
                hasFocus: false, // This will be triggered when the 'newMessage' input gets the current focus
                isCollapsed: collapseWindow,
                hasNewMessage: false
            };

            // Loads the chat history via an RxJs Observable
            if (this.historyEnabled)
            {
                this.adapter.getMessageHistory(newChatWindow.chattingTo.id).pipe(
                map((result: ChatP[]) => {
                    //newChatWindow.messages.push.apply(newChatWindow.messages, result);
                    newChatWindow.messages = newChatWindow.messages;
                    newChatWindow.isLoadingHistory = false;

                    setTimeout(() => { this.scrollChatWindowToBottom(newChatWindow)});
                })).subscribe();
            }

            this.windows.unshift(newChatWindow);

            // Is there enough space left in the view port ?
            if (this.windows.length * this.windowSizeFactor >= this.viewPortTotalArea - this.friendsListWidth)
            {                
                this.windows.pop();
            }

            this.updateWindowsState(this.windows);
            
            if (focusOnNewWindow && !collapseWindow) 
            {
                invokedByUserClick ? this.focusOnWindow(newChatWindow) : null;
            }
            
            this.onUserChatOpened.emit({chat: user, invokedByUserClick: invokedByUserClick});

            return [newChatWindow, true];
        }
        else
        {
            //this.focusOnWindow(openedWindow);
            // Returns the existing chat window     
            return [openedWindow, false];       
        }
    }

    // Focus on the input element of the supplied window
    private focusOnWindow(window: Window, callback: Function = () => {}) : void
    {
        let windowIndex = this.windows.indexOf(window);

        if (windowIndex >= 0)
        {
            setTimeout(() => {
                if (this.chatWindowInputs)
                {
                    let messageInputToFocus = this.chatWindowInputs.toArray()[windowIndex];
                
                    messageInputToFocus.nativeElement.focus(); 
                }

                callback(); 
            });
        } 
    }

    // Scrolls a chat window message flow to the bottom
    private scrollChatWindowToBottom(window: Window): void
    {
        if (!window.isCollapsed){
            let windowIndex = this.windows.indexOf(window);

            setTimeout(() => {
                if (this.chatMessageClusters)
                    this.chatMessageClusters.toArray()[windowIndex].nativeElement.scrollTop = this.chatMessageClusters.toArray()[windowIndex].nativeElement.scrollHeight;
            }); 
        }
    }

    // Marks all messages provided as read with the current time.
    private markMessagesAsRead(messages: ChatP[]): void
    {
        let currentDate = new Date();

        messages.forEach((msg)=>{
            // msg.to.last_login = currentDate;
        });
    }

    // Buffers audio file (For component's bootstrapping)
    private bufferAudioFile(): void {
        if (this.audioSource && this.audioSource.length > 0)
        {
            this.audioFile = new Audio();
            this.audioFile.src = this.audioSource;
            this.audioFile.load();
        }
    }

    // Emits a message notification audio if enabled after every message received
    private emitMessageSound(window: Window): void
    {
        if (this.audioEnabled && !window.hasFocus && this.audioFile) {
            this.audioFile.play();
        }
    }

    // Emits a browser notification
    private emitBrowserNotification(window: Window, message: ChatP): void
    {       
        if (this.browserNotificationsBootstrapped && !window.hasFocus && message) {
            let notification = new Notification(`${this.localization.browserNotificationTitle} ${window.chattingTo.to.name}`, {
                'body': window.messages[window.messages.length - 1].message,
                'icon': this.browserNotificationIconSource
            });

            setTimeout(() => {
                notification.close();
            }, message.message.length <= 50 ? 5000 : 7000); // More time to read longer messages
        }
    }

    // Saves current windows state into local storage if persistence is enabled
    private updateWindowsState(windows: Window[]): void
    {
        if (this.persistWindowsState)
        {
            let usersIds = windows.map((w) => {
                return w.chattingTo.id;
            });

            localStorage.setItem(this.localStorageKey, JSON.stringify(usersIds));
        }
    }

    private restoreWindowsState(): void
    {
        try
        {
            if (this.persistWindowsState)
            {
                let stringfiedUserIds = localStorage.getItem(this.localStorageKey);

                if (stringfiedUserIds && stringfiedUserIds.length > 0)
                {
                    let userIds = <number[]>JSON.parse(stringfiedUserIds);

                    let usersToRestore = this.users.filter(u => userIds.indexOf(u.id) >= 0);

                    usersToRestore.forEach((user) => {
                        this.openChatWindow(user);
                    });
                }
            }
        }
        catch (ex)
        {
            console.log(`An error occurred while restoring ng-chat windows state. Details: ${ex}`);
        }
    }

    // Gets closest open window if any. Most recent opened has priority (Right)
    private getClosestWindow(window: Window): Window | undefined
    {   
        let index = this.windows.indexOf(window);

        if (index > 0)
        {
            return this.windows[index - 1];
        }
        else if (index == 0 && this.windows.length > 1)
        {   
            return this.windows[index + 1];
        }
    }

    // Returns the total unread messages from a chat window. TODO: Could use some Angular pipes in the future 
    unreadMessagesTotal(window: Window): string
    {
        if (window){
            if (window.hasFocus){
                this.markMessagesAsRead(window.messages);
            }
            else{
                // let totalUnreadMessages = window.messages.filter(x => x.fromId != this.userId && !x.seenOn).length;
                
                // if (totalUnreadMessages > 0){

                //     if (totalUnreadMessages > 99) 
                //         return  "99+";
                //     else
                //         return String(totalUnreadMessages); 
                // }
            }
        }
            
        // Empty fallback.
        return "";
    }

    unreadMessagesTotalByUser(user: ChatP): string
    {
        let openedWindow = this.windows.find(x => x.chattingTo.id == user.id);

        if (openedWindow){
            return this.unreadMessagesTotal(openedWindow);
        }
            
        // Empty fallback.
        return "";
    }

    sendTyping(to: User) {
        const setTyping = (value) => {
            this.typing = value;
          }
    
        //   const getTo = () => {
        //     return this.currentChat.to;
        //   }
    
          if(this.typing == false) {
            this.typing = true;
            this.socketService.sendTyping(new ChatP(AuthService.getUser(), to, 'typing'));
    
            this.timeout = setTimeout(() => {
              setTyping(false);
              SocketService.getInstance().sendStopTyping(new ChatP(AuthService.getUser(), to, 'stop typing'));
            }, 2000);
          } else {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              setTyping(false);
              SocketService.getInstance().sendStopTyping(new ChatP(AuthService.getUser(), to, 'stop typing'));
            }, 2000);
          }
    }

    /*  Monitors pressed keys on a chat window
        - Dispatches a message when the ENTER key is pressed
        - Tabs between windows on TAB or SHIFT + TAB
        - Closes the current focused window on ESC
    */
    onChatInputTyped(event: any, window: Window): void
    {
        switch (event.keyCode)
        {
            case 13:
                event.preventDefault();
                
                if (window.newMessage && window.newMessage.trim() != "")
                {
                    //debugger

                    const message = new ChatP(
                        AuthService.getUser(),
                        window.chattingTo.to,
                        window.newMessage,
                        true
                      );
              
                     let chat = AuthService.chats.find(x => x.to.id == window.chattingTo.to.id);
                     chat.messages.push(message);
             
                    // message.fromId = this.userId;
                    // message.toId = window.chattingTo.id;
                    // message.message = window.newMessage;
        
                     //window.messages.push(message);
        
                     this.adapter.sendMessage(message);
                     this.onSentMessage.emit(message);
        
                    window.newMessage = ""; // Resets the new message input

                    this.scrollChatWindowToBottom(window);
                }
                break;
            case 9:
                event.preventDefault();
                
                let currentWindowIndex = this.windows.indexOf(window);
                let messageInputToFocus = this.chatWindowInputs.toArray()[currentWindowIndex + (event.shiftKey ? 1 : -1)]; // Goes back on shift + tab

                if (!messageInputToFocus)
                {
                    // Edge windows, go to start or end
                    messageInputToFocus = this.chatWindowInputs.toArray()[currentWindowIndex > 0 ? 0 : this.chatWindowInputs.length - 1]; 
                }

                messageInputToFocus.nativeElement.focus();

                break;
            case 27:
                let closestWindow = this.getClosestWindow(window);

                if (closestWindow)
                {
                    this.focusOnWindow(closestWindow, () => { this.onCloseChatWindow(window); });
                }
                else
                {
                    this.onCloseChatWindow(window);
                }
        }

        if(event.keyCode != 13 && event.keyCode != 1) {
            this.sendTyping(window.chattingTo.to);
        }
    }

    sendMessage(window) {
        if (window.newMessage && window.newMessage.trim() != "")
            {
                //debugger

                const message = new ChatP(
                    AuthService.getUser(),
                    window.chattingTo.to,
                    window.newMessage,
                    true
                );
        
                let chat = AuthService.chats.find(x => x.to.id == window.chattingTo.to.id);
                chat.messages.push(message);
        
                // message.fromId = this.userId;
                // message.toId = window.chattingTo.id;
                // message.message = window.newMessage;

                //window.messages.push(message);

                this.adapter.sendMessage(message);
                this.onSentMessage.emit(message);

                window.newMessage = ""; // Resets the new message input

                this.scrollChatWindowToBottom(window);
            }        
    }

    onFocusInput(window) {
        console.log('FOCUS WINDOW > ' + window.hasFocus);

        if(!window.hasFocus) {
            AuthService.chats.map(x => {
                if(x.to.id == window.chattingTo.to.id) {
                    x.countNewMessage = 0;
                }
            });

            this.chatService.markAsSeen({from: window.chattingTo.to.id, to: window.chattingTo.from.id}).subscribe(resp => {
                console.log(resp);
                this.socketService.sendMarkMessageSeen(window.chattingTo);
            });
            
        }
    }

    setFocusWindow(windows) {
        this.focusOnWindow(windows);
    }

    onFocusChatContent(window) {
        console.log('FOCUS CHAT CONTENT ');

        // if(!window.chattingTo.seen) {
        //     AuthService.chats.map(x => {
        //         if(x.to.id == window.chattingTo.to.id) {
        //             x.countNewMessage = 0;
        //             x.seen = true;
        //         }
        //     });

        //     this.chatService.markAsSeen({from: window.chattingTo.to.id, to: window.chattingTo.from.id}).subscribe(resp => {
        //         console.log(resp);
        //         this.socketService.sendMarkMessageSeen(window.chattingTo);
        //     });
        // }
    }

    // Closes a chat window via the close 'X' button
    onCloseChatWindow(window: Window): void 
    {
        let index = this.windows.indexOf(window);

        this.windows.splice(index, 1);

        this.updateWindowsState(this.windows);

        this.onUserChatClosed.emit(window.chattingTo);

        window.chattingTo.seen = false;
    }

    // Toggle friends list visibility
    onChatTitleClicked(event: any): void
    {
        this.isCollapsed = !this.isCollapsed;
    }

    // Toggles a chat window visibility between maximized/minimized
    onChatWindowClicked(window: Window): void
    {
        window.isCollapsed = !window.isCollapsed;
        this.scrollChatWindowToBottom(window);
        !window.isCollapsed ? this.focusOnWindow(window) : null;
    }

    // Asserts if a user avatar is visible in a chat cluster
    isAvatarVisible(window: Window, message: Message, index: number): boolean
    {
        if (message.fromId != this.userId){
            if (index == 0){
                return true; // First message, good to show the thumbnail
            }
            else{
                // Check if the previous message belongs to the same user, if it belongs there is no need to show the avatar again to form the message cluster
                // if (window.messages[index - 1].fromId != message.fromId){
                //     return true;
                // }
            }
        }

        return false;
    }

    // Toggles a window focus on the focus/blur of a 'newMessage' input
    toggleWindowFocus(window: Window): void
    {
        window.hasFocus = !window.hasFocus;
        console.log('FOCUS WINDOW > ' + window.hasFocus);

        if(window.hasFocus) {
            AuthService.chats.map(x => {
                if(x.to.id == window.chattingTo.to.id) {
                    x.countNewMessage = 0;
                }
            });

            window.hasNewMessage = false;

            this.chatService.markAsSeen({from: window.chattingTo.to.id, to: window.chattingTo.from.id}).subscribe(resp => {
                console.log(resp);
                this.socketService.sendMarkMessageSeen(window.chattingTo);
            });

            this.setCountIconChats();
        }
    }

    // [Localized] Returns the status descriptive title
    getStatusTitle(status: number) : any
    {
        switch(status) {
            case 0: return 'Desconectado'
            case 1: return 'En línea'
            case 2: return 'Ocupado'
            case 3: return 'No molestar'
        }
    }

    setCountIconChats() {
        if(this.router.url != '/chat') {
          const componentRef = this.componentFactoryResolver.resolveComponentFactory(IconChatsComponent).create(this.injector);        
            
          this.applicationRef.attachView(componentRef.hostView);
              
          let instance = <IconChatsComponent>componentRef.instance;
    
          let count = 0;
    
          AuthService.chats.filter(x => {
            count += x.countNewMessage;
          });
    
          instance.countChatMessage = count;
    
          const elem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            
          const sidenav = document.getElementById('divIconChats');        
          sidenav.replaceChild(elem, sidenav.children[0]);     
        }
      }

      openNewChat(sidenav: any) {
        this.isCollapsed ? this.isCollapsed = false : null;
        sidenav.toggle();
        setTimeout(() => {
          this.searchUser.nativeElement.focus();
        }, 500);
      }

      newChat(user: User, sidenav) {
        sidenav.toggle();
        const newChat = new ChatP(AuthService.getUser(), user, '', true);
    
        newChat.messages = AuthService.chats.find(x => x.from.id == AuthService.getUser().id && x.to.id == newChat.to.id)
                      ? AuthService.chats.find(x => x.from.id == AuthService.getUser().id && x.to.id == newChat.to.id).messages : [];

        AuthService.chats.push(newChat);
        this.openChatWindow(newChat, true, true);                      
      }

}

